import styled from "styled-components";
import {TableCell, TableCellProps} from "@mui/material";

export const DivFilter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.2vh;
`;

export const DivDataTable = styled.div`
  display: flex;
  border-top: 2px solid #1f299c;
  padding-top: 1vh;
`;

interface IStyledDivDataTableProps extends TableCellProps {
  width?: number;
}

export const StyledDivDataTable = styled(TableCell)<IStyledDivDataTableProps>`
  &&{
    background-color: #D0D2EA;
    width: ${props => props.width}%;
  }
`;
